import { Button, Col, Drawer, Form, Input, Row, Select } from "antd";
import { useEffect, useState } from "react";
import "react-phone-input-2/lib/style.css";

import ProfileUpload from "../../components/ProfileUpload";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";

const AddForm = ({ api, show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [image, setImage] = useState();
  const [loading, setLoading] = useState(false);
  const [removing, setRemoving] = useState(false);

  const allowedImageTypes = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/webp",
  ];

  const handleImage = (fileList) => {
    const validFile = fileList?.find(
      (file) => file.status !== "removed" && (file.url || file.thumbUrl)
    );

    if (validFile) {
      const url = validFile.url || validFile.thumbUrl || null;
      setImage(url);
      form.setFieldsValue({ image: url });
    } else {
      setImage(null);
      form.setFieldsValue({ image: null });

      if (data && data._id) {
        setRemoving(true);
        request({
          url: `${api.addEdit}/${data._id}`,
          method: "POST",
          data: { ...data, image: null },
          onSuccess: (res) => {
            setRemoving(false);
            if (res.status) {
              ShowToast("Profile image removed successfully", Severty.SUCCESS);
              refresh();
            } else {
              ShowToast(res.message, Severty.ERROR);
            }
          },
          onError: (error) => {
            setRemoving(false);
            ShowToast(
              error?.response?.data?.message || "Failed to remove image",
              Severty.ERROR
            );
          },
        });
      }
    }
  };

  useEffect(() => {
    if (data) {
      const imageUrl = data?.image || null;
      setImage(imageUrl);

      form.setFieldsValue({
        name: data.name ?? "",
        email: data.email ?? "",
        image: imageUrl,
        roles: data.roles ?? undefined,
        initial_credit: data.initial_credit ?? undefined,
      });
    } else {
      form.resetFields();
      setImage(null);
    }
  }, [data]);

  const onCreate = (values) => {
    setLoading(true);
    const payload = {
      ...values,
      image,
      initial_credit: values.initial_credit || 0,
    };

    request({
      url: `${data ? api.addEdit + "/" + data._id : api.addEdit}`,
      method: "POST",
      data: payload,
      onSuccess: (res) => {
        setLoading(false);
        if (res.status) {
          ShowToast(res.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(res.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error.response?.data?.message, Severty.ERROR);
      },
    });
  };

  return (
    <Drawer
      title={`${data ? "Edit" : "Add"} User`}
      width={window.innerWidth < 768 ? "100%" : 500}
      onClose={() => {
        hide();
        form.resetFields();
        setImage(null);
      }}
      open={show}
      destroyOnClose
      footer={null}
    >
      <Form form={form} layout="vertical" onFinish={onCreate}>
        <Row gutter={[16, 0]}>
          <Col span={24} style={{ textAlign: "center" }}>
            <Form.Item
              name="image"
              // rules={[
              //   { required: true, message: "Please upload a profile image" },
              // ]}
            >
              <ProfileUpload
                value={image ? [{ url: image }] : []}
                fileType={allowedImageTypes}
                imageType="image"
                btnName={"Upload Profile Image"}
                onChange={handleImage}
              />
              <div
                style={{ marginTop: "8px", fontSize: "12px", color: "#999" }}
              >
                ⚠️ Image should be under 5MB (JPG, PNG, WEBP)
              </div>
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label="Full Name"
              name="name"
              normalize={(value) => value?.trimStart()}
              rules={[{ required: true, message: "Please enter name" }]}
            >
              <Input autoComplete="off" placeholder="Enter full name" />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label="Email Address"
              name="email"
              normalize={(value) => value?.trim().toLowerCase()}
              rules={[
                {
                  required: true,
                  message: "Please enter your email address!",
                },
                {
                  pattern:
                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|in|org|net|edu|co|gov|info)$/,
                  message:
                    "Enter a valid email address with a proper extension (e.g. .com, .in)",
                },
                {
                  validator: (_, value) => {
                    if (/\s/.test(value)) {
                      return Promise.reject("Email must not contain spaces.");
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input autoComplete="off" placeholder="Enter email" />
            </Form.Item>
          </Col>

          {/* <Col span={24}>
            <Form.Item label="Assign Role" name="roles">
              <Select placeholder="Select Role" allowClear>
                <Select.Option value="admin">Admin</Select.Option>
                <Select.Option value="user">User</Select.Option>
                <Select.Option value="moderator">Moderator</Select.Option>
              </Select>
            </Form.Item>
          </Col> */}

          <Col span={24}>
            <Form.Item
              label="Initial Credit (Optional)"
              name="initial_credit"
              rules={[
                {
                  type: "number",
                  min: 0,
                  message: "Credit must be 0 or more",
                  transform: (value) => Number(value || 0),
                },
              ]}
            >
              <Input type="number" placeholder="Enter initial credit" />
            </Form.Item>
          </Col>

          <Col span={24}>
            <div className="d-flex justify-content-end">
              <Button type="default" style={{ marginRight: 8 }} onClick={hide}>
                Cancel
              </Button>
              <Button type="primary" htmlType="submit" loading={loading}>
                {data ? "Update" : "Add"}
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </Drawer>
  );
};

export default AddForm;
